import styled from 'styled-components';
import {
  FrameHeaderHeight,
  FrameSidebarWidth,
  MobileFrameHeaderHeight,
} from 'styles/constants';

type SpacingProps = {
  active: boolean;
};

export const SpacingToAvoidFrameDesktop = styled.div<SpacingProps>(
  ({ active }) => {
    if (!active) return {};
    return {
      paddingTop: `${FrameHeaderHeight}px`,
      paddingLeft: `${FrameSidebarWidth}px`,
    };
  },
);

export const SpacingToAvoidFrameMobile = styled.div<SpacingProps>(
  ({ active }) => {
    if (!active) return {};
    return {
      paddingTop: `${MobileFrameHeaderHeight}px`,
    };
  },
);
